module.exports = __webpack_public_path__ + "media/components/resources/vertical-grid/img/blank-103f82cb49b0d3f1fbc25493182bae28.png";